import { z } from 'zod';

export const createVendorContactSchema = z.object({
  name: z.string().min(1).max(255),
  email: z.string().email().max(255).optional().nullable(),
  phone: z.string().max(50).optional().nullable(),
  role: z.string().max(100).optional().nullable(),
  isPrimary: z.boolean().default(false),
});

export const updateVendorContactSchema = z.object({
  name: z.string().min(1).max(255).optional(),
  email: z.string().email().max(255).optional().nullable(),
  phone: z.string().max(50).optional().nullable(),
  role: z.string().max(100).optional().nullable(),
  isPrimary: z.boolean().optional(),
});

export type CreateVendorContactInput = z.infer<typeof createVendorContactSchema>;
export type UpdateVendorContactInput = z.infer<typeof updateVendorContactSchema>;
